import { render, staticRenderFns } from "./SearchWordSelect.vue?vue&type=template&id=75423eee&"
import script from "./SearchWordSelect.vue?vue&type=script&lang=ts&"
export * from "./SearchWordSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports